import React from 'react';
import { XIcon, AlertTriangleIcon, ClockIcon, TruckIcon, CookingPotIcon } from 'lucide-react';
export const Problem = () => {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-277">
      <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-278">
        <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-279">
          Lo que nadie te dijo
        </h2>
        <p className="text-xl text-gray-700 mb-8" data-id="element-280">
          No es tu culpa. Es el sistema que nunca te dieron.
        </p>
      </div>
      <div className="max-w-5xl mx-auto" data-id="element-281">
        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-282">
          <div className="space-y-6" data-id="element-283">
            <div className="flex items-start gap-4" data-id="element-284">
              <div className="bg-red-100 p-2 rounded-full" data-id="element-285">
                <XIcon className="h-6 w-6 text-red-600" data-id="element-286" />
              </div>
              <div data-id="element-287">
                <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-288">
                  Comés apurado
                </h3>
                <p className="text-gray-700" data-id="element-289">
                  Sin tiempo para preparar comidas saludables
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-290">
              <div className="bg-red-100 p-2 rounded-full" data-id="element-291">
                <TruckIcon className="h-6 w-6 text-red-600" data-id="element-292" />
              </div>
              <div data-id="element-293">
                <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-294">
                  Caés en delivery
                </h3>
                <p className="text-gray-700" data-id="element-295">Gastando más y comiendo peor</p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-296">
              <div className="bg-red-100 p-2 rounded-full" data-id="element-297">
                <CookingPotIcon className="h-6 w-6 text-red-600" data-id="element-298" />
              </div>
              <div data-id="element-299">
                <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-300">
                  Airfryer como adorno
                </h3>
                <p className="text-gray-700" data-id="element-301">
                  Un aparato costoso que apenas usás
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-302">
              <div className="bg-red-100 p-2 rounded-full" data-id="element-303">
                <AlertTriangleIcon className="h-6 w-6 text-red-600" data-id="element-304" />
              </div>
              <div data-id="element-305">
                <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-306">
                  El verdadero problema
                </h3>
                <p className="text-gray-700" data-id="element-307">
                  No es la comida. Es el caos. Texturas flojas. Calorías
                  ocultas.
                </p>
              </div>
            </div>
          </div>
          <div className="flex justify-center" data-id="element-308">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vh7P12CLw1gsCy2YrhMWGi/e5f1bfc7-cd75-4f33-bfde-49aa6460e46b.png" alt="Desayuno saludable preparado con Airfryer" className="rounded-lg shadow-lg w-full max-w-md" data-id="element-309" />
          </div>
        </div>
      </div>
    </section>;
};